import { functions } from "../../../utils/firebase";

export const updateUserTeamsUsage = async (userId) => {
  try {
    const dashboardUpdateUserTeamsUsage = functions.httpsCallable(
      "dashboardUpdateUserTeamsUsage"
    );
    const result = await dashboardUpdateUserTeamsUsage({
      userId,
      saveToDb: true,
    });

    if (result.data.status === "max-size-exceeded") {
      return { status: "max-size-exceeded", stats: result.data.stats };
    } else if (result.data.status === "success") {
      return { status: "success", stats: result.data.stats };
    }
  } catch (error) {
    return { status: "error", stats: null };
  }
};

export const getTotalMembersWithUsage = (stat) => {
  if (!stat?.uniqueUsers || typeof stat.uniqueUsers !== "object") {
    return 0;
  }

  // Create a Set to store unique user IDs
  const uniqueUserIds = new Set();

  // Check if item has uniqueUsers object
  if (stat.uniqueUsers && typeof stat.uniqueUsers === "object") {
    // Add all user IDs from uniqueUsers object to our Set
    Object.keys(stat.uniqueUsers).forEach((userId) => {
      uniqueUserIds.add(userId);
    });
  }

  // Return the total count of unique users
  return uniqueUserIds.size;
};
